import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=9a0472ba&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=9a0472ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0472ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a0472ba')) {
      api.createRecord('9a0472ba', component.options)
    } else {
      api.reload('9a0472ba', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=9a0472ba&scoped=true&", function () {
      api.rerender('9a0472ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23DGhAcOnW510/JS/comp/GuestBoxKids.vue"
export default component.exports